"use client";

import React, { createContext, useContext } from "react";

// Defaults to visible so menus rendered outside the Procure layout keep the item.
const GetStartedNavContext = createContext(true);

/** Tells the nav menus whether to show the "Get Started" item. */
export function GetStartedNavProvider({
  visible,
  children,
}: {
  visible: boolean;
  children: React.ReactNode;
}) {
  return (
    <GetStartedNavContext.Provider value={visible}>
      {children}
    </GetStartedNavContext.Provider>
  );
}

export const useShowGetStartedNav = () => useContext(GetStartedNavContext);
